import { getSprintWorkspacePath } from "../../api/trustbuds";

function cleanValue(value) {
  if (value === null || value === undefined) return null;
  const normalized = String(value).trim();
  return normalized || null;
}

function firstName(value) {
  const fullName = cleanValue(value);
  if (!fullName) return null;
  return fullName.split(/\s+/)[0] || fullName;
}

export class ConversationThread {
  constructor({ connectionId, partnerUserId, sprintId, partnerName } = {}) {
    this.connectionId = cleanValue(connectionId);
    this.partnerUserId = cleanValue(partnerUserId);
    this.sprintId = cleanValue(sprintId);
    this.partnerName = cleanValue(partnerName);
  }

  get hasActiveSprint() {
    return Boolean(this.sprintId);
  }

  get messageLabel() {
    const first = firstName(this.partnerName);
    return first ? `Message ${first}` : "Message them";
  }

  get journeyPath() {
    if (this.connectionId) return `/activity/chats/${this.connectionId}/`;
    return null;
  }

  get journeyReadPath() {
    if (this.connectionId) return `/activity/chats/${this.connectionId}/read/`;
    return null;
  }

  get messagePath() {
    if (this.connectionId) return `/activity/chats/${this.connectionId}/messages/`;
    return null;
  }

  getRoute({ compose = false, focus = null, source = null, message = "", quickAction = "" } = {}) {
    if (this.sprintId) {
      return getSprintWorkspacePath({
        sprintId: this.sprintId,
        connectionId: this.connectionId,
        userId: this.partnerUserId,
        focus,
        source,
      });
    }

    if (this.connectionId || this.partnerUserId) {
      const params = new URLSearchParams();
      params.set("tab", "messages");
      if (this.connectionId) params.set("connectionId", this.connectionId);
      if (this.partnerUserId) params.set("userId", this.partnerUserId);
      if (compose) params.set("compose", "1");
      if (message) params.set("message", message);
      if (quickAction) params.set("quickAction", quickAction);
      return `/activity?${params.toString()}`;
    }

    return "/activity?tab=messages";
  }

  static fromConnection(connection) {
    return new ConversationThread({
      connectionId: connection?.connectionId,
      partnerUserId: connection?.userId,
      sprintId: connection?.sprintId,
      partnerName: connection?.name,
    });
  }

  static fromThread(thread) {
    return new ConversationThread({
      connectionId: thread?.connectionId || thread?.id,
      partnerUserId: thread?.partner?.id || thread?.other_user?.id,
      sprintId: thread?.activeSprint?.id || thread?.active_sprint?.id,
      partnerName: thread?.partner?.username || thread?.other_user?.username,
    });
  }

  static fromPersonContext(person) {
    return new ConversationThread({
      connectionId: person?.connection_id,
      partnerUserId: person?.user_id,
      sprintId: person?.sprint_id,
      partnerName: person?.name,
    });
  }
}
